import{b as W,c as b}from"./utils-DEtfA7nQ.js";import{i as X,g as B}from"./pdp-promo-DkDIj8ZV.js";const et=o=>{const a=new Set;return o.forEach(t=>{const e=(t.products?t.products[0]:t).custom,l=(e==null?void 0:e.product_sets_top)||[],r=(e==null?void 0:e.products_sets_bottom)||[];[...l,...r].forEach(c=>{c.id&&a.add(c.id)})}),[...a]},ct=async o=>{var p,d;if(!o.length)return{};const a="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,i]=window.location.pathname.split("/"),l=((i||"").split("-")[1]||"gb").toUpperCase(),r=o.map(n=>`gid://shopify/Product/${n}`),c=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${l}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const h=await(await fetch(a,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:c,variables:{ids:r}})})).json(),s={};return(d=(p=h.data)==null?void 0:p.nodes)==null||d.forEach(u=>{if(u!=null&&u.id){const f=u.id.replace("gid://shopify/Product/","");s[f]=parseFloat(u.priceRange.minVariantPrice.amount)}}),s}catch(n){return console.error("Failed to fetch set product prices:",n),{}}},D=new Set,st=async o=>{var l,r;if(!o.length)return{};const a="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,i=o.map(c=>`gid://shopify/Product/${c}`),e=`
    query GetCollaborationColors($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          tags
          collaborationColor: metafield(namespace: "magento", key: "color") {
            value
          }
        }
      }
    }
  `;try{const p=await(await fetch(a,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:e,variables:{ids:i}})})).json(),d={};return(r=(l=p.data)==null?void 0:l.nodes)==null||r.forEach(n=>{var u,f;if(!(n!=null&&n.id))return;const h=n.id.replace("gid://shopify/Product/",""),s=(u=n.collaborationColor)==null?void 0:u.value;s&&(d[h]=s),(f=n.tags)!=null&&f.includes(window.themeVars.promoPricingTag)&&D.add(h)}),d}catch(c){return console.error("Failed to fetch collaboration colours:",c),{}}},nt=async o=>{var l,r;if(!o.length||!X())return{};const a="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,i=o.map(c=>`gid://shopify/Product/${c}`),e=`
    query GetProductTags($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          tags
        }
      }
    }
  `;try{const p=await(await fetch(a,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:e,variables:{ids:i}})})).json(),d={};return(r=(l=p.data)==null?void 0:l.nodes)==null||r.forEach(n=>{n!=null&&n.id&&(d[n.id.replace("gid://shopify/Product/","")]=n.tags||[])}),d}catch(c){return console.error("Failed to fetch product tags:",c),{}}},R=(o,a)=>{if(!a||!Object.keys(a).length)return null;const t=o.custom,i=(t==null?void 0:t.product_sets_top)||[],e=(t==null?void 0:t.products_sets_bottom)||[],l=[...i,...e];if(!l.length)return null;let r=1/0;return l.forEach(c=>{const p=a[c.id];p!==void 0&&p<r&&(r=p)}),r===1/0?null:r},U=o=>{if(!Array.isArray(o)||o.length===0)return"";const a=new Map;return o.forEach(t=>{const i=t==null?void 0:t.url,e=Number(t==null?void 0:t.width);!i||!Number.isFinite(e)||e<=0||a.has(e)||a.set(e,i)}),a.size===0?"":[...a.entries()].sort(([t],[i])=>t-i).map(([t,i])=>`${i} ${t}w`).join(", ")},K=(o,a)=>{var l;if(!Array.isArray(o)||o.length===0)return a||"";const t=o.filter(r=>(r==null?void 0:r.url)&&Number(r==null?void 0:r.width)>0);if(t.length===0)return((l=o[0])==null?void 0:l.url)||a||"";const i=600;return t.reduce((r,c)=>{const p=Math.abs(Number(r.width)-i);return Math.abs(Number(c.width)-i)<p?c:r}).url},it=(o,{isSlide:a=!1,index:t=99,setProductPrices:i={},collaborationColors:e={},productTags:l={}}={})=>{var A,V,j,F,I,q,N,O,E,M,z,x;const{key:r,title:c,link:p,imageInfo:d,sellingPrice:n,listPrice:h,custom:s,ticket:u}=o,f=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",P=((V=(A=d==null?void 0:d.images)==null?void 0:A[0])==null?void 0:V.sources)||[],L=K(P,d==null?void 0:d.thumbnail),S=U(P),G="(min-width: 1024px) 25vw, 50vw",y=(n==null?void 0:n.min)||0,g=(h==null?void 0:h.min)>(n==null?void 0:n.min)?h.min:0,k=D.has(String(r)),m=(F=(j=s==null?void 0:s.product_hover_image)==null?void 0:j[0])==null?void 0:F.label,_=(q=(I=s==null?void 0:s.colour_count)==null?void 0:I[0])==null?void 0:q.label,$=(O=(N=s==null?void 0:s.collaboration_name)==null?void 0:N[0])==null?void 0:O.label,v=W((M=(E=s==null?void 0:s.collaboration_link)==null?void 0:E[0])==null?void 0:M.label),C=e[r],T=/^#[0-9a-f]{3,8}$/i.test(C||"")?` style="--collaboration-tag-color: ${C};"`:"",H=t<=2?"eager":"lazy",J=t<=2?"high":"auto",w=((z=s==null?void 0:s.product_sets_top)==null?void 0:z.length)>0||((x=s==null?void 0:s.products_sets_bottom)==null?void 0:x.length)>0?R(o,i):null;return`
    <${a?"li":"div"}
      class="product-card ${k?"product-card--promo":""} ${a?"splide__slide":""}"
      data-voyado-product
      data-product-key="${r}"
      data-product-ticket="${u}"
    >
      ${Z(s,y,g,k)}
      ${tt(o)}
      <a
        href="${f}${p}"
        class="product-card__image-container ${m?"has-hover":""}"
        aria-label="${c}"
      >
        <img
          src="${L}"
          ${S?`srcset="${S}" sizes="${G}"`:""}
          alt="Image of ${c}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${H}"
          fetchpriority="${J}"
        />
        ${m?`
          <img
            src="${m}"
            alt="Secondary image of ${c}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <div class="product-card__title-wrapper">
          <a href="${f}${p}" aria-label="${c}" class="product-card__title f1-lc">${c}</a>
          ${$?v?`<a href="${v}" class="product-card__collaboration f2-uc"${T}>${$}</a>`:`<p class="product-card__collaboration f2-uc"${T}>${$}</p>`:""}
        </div>
        ${w!==null?Q(w):Y(y,g)}
      </div>
       <p
        data-product-id="${r}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${_&&_>1?`
        <p class="product-card__colour-count f2-lc">
          ${_} Colours
        </p>
      `:""}
      ${w!==null?"":B({tags:l[r],price:y,comparePrice:g})}
    </${a?"li":"div"}>
  `},Q=o=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${b(o)}
      </span>
    </div>`,Y=(o,a)=>a?`
    <div class="product-card__price">
      <span class="visually-hidden">Original price:</span>
      <s class="product-card__price--original f1-lc">${b(a)}</s>
      <span class="visually-hidden">Sale price:</span>
      <span class="product-card__price--discounted f1-lc">${b(o)}</span>
    </div>`:`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">${b(o)}</span>
    </div>`,Z=(o,a,t,i)=>{if(!i&&t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-a/t)*100)}% OFF
      </p>
    `;const e=r=>{var p,d;const c=(d=(p=o==null?void 0:o[r])==null?void 0:p[0])==null?void 0:d.label;return c&&!c.includes("-")?c:""},l=e("stock")||e("petite")||e("fabric")||e("nc_exclusive")||e("new")||e("available_to_rent")||e("back_in_stock");return l?`
      <p class="product-card__label product-label product-label--default">
        ${l}
      </p>
    `:""},tt=o=>{var t;const a=((t=o.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${o.key}"
      data-product-handle="${a}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{st as a,nt as b,et as c,it as d,ct as f};
